import React from 'react'

export const PageHeader: React.FunctionComponent = () => {
  return (
    <div className="page-header">
      <h1 className="page-title">Manage Deals</h1>
    </div>
  )
}
